import React, { ReactNode, VFC } from 'react';
import ReactLinkify from 'react-linkify';

interface Props {
  children: ReactNode;
}
const Linkify: VFC<Props> = ({ children }: Props) => {
  const componentDecorator = (href, text, key) => (
    <a key={key} href={href} target="_blank" rel="noreferrer">
      {text}
    </a>
  );

  return (
    <ReactLinkify componentDecorator={componentDecorator}>
      {children}
    </ReactLinkify>
  );
};

export default Linkify;
